﻿window.cObjetCompteEmailMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "compte email"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau compte email"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { var txt = objet.data.adresse_email }
        else {
            txt = "adresse email"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-at' title='Compte email'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        if (objet.data.reception_prevenir_desactivation == "1" || objet.data.envoi_prevenir_desactivation == "1") {
            objet.data.reception_prevenir_desactivation = "0"
            objet.data.envoi_prevenir_desactivation = "0"
            objet.mSave()
        }
        var dataCompteEmailUtilisateur = Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (o) { return o.id_utilisateur == option.id_utilisateur && o.id_compte_email == objet.data.id_compte_email })[0]
        var dataCompteEmailCloneReception = JSON.clone(objet.data)
        var dxCtrlCompteEmailConfigReception = null
        var dataCompteEmailCloneEnvoi = JSON.clone(objet.data)
        var dxCtrlCompteEmailConfigEnvoi = null
        if (typeof dataCompteEmailUtilisateur == 'undefined') {
            dataCompteEmailUtilisateur = Me.objet.bddRef.getObjet("compte_email_utilisateur").mGetNewData()
            dataCompteEmailUtilisateur.id_utilisateur = option.id_utilisateur
            dataCompteEmailUtilisateur.id_compte_email = objet.data.id_compte_email
            Me.objet.bddRef.getObjet(dataCompteEmailUtilisateur).mSave(function (data) { mRempli() })
        } else { mRempli() }
        var currentSelectedIndex = 0
        if (typeof option.idAccordion != 'undefined') currentSelectedIndex = option.idAccordion
        function mRempli() {
            var ds = [{ txt: "Général" }, { txt: "Réception" }, { txt: "envoi" }, { txt: "Spécifications des envois en nombre" }]
            var dxAccordion = $("<div class='accordionemail'/>").appendTo(contentElement).dxAccordion({
                dataSource: ds,
                selectedItem: ds[option.idAccordion],
                itemTitleTemplate: function (itemData, itemIndex, titleElement) {
                    titleElement.css("font-size", "20px");
                    titleElement.css("line-height", "0.7");
                    titleElement.addClass("dx-theme-accent-as-text-color")
                    itemData.titleElement = titleElement;
                    mChangeTitle(itemData)
                },
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    switch (itemIndex) {
                        case 0:
                            $("<div/>").appendTo(itemElement).dxCtrlCompteEmailGeneral({
                                bddCtrl: Me.objet.bddRef,
                                dataCompteEmail: dataCompteEmailCloneReception,
                                dataCompteEmailUtilisateur: dataCompteEmailUtilisateur,
                                allowSave: true,
                                allowSignature: true,
                                allowRepAuto: true,
                                allowConfidentiel: true,
                                allowPartage: true
                            })
                            break;
                        case 1:
                            //dataCompteEmailCloneReception = JSON.clone(dataCompteEmailUtilisateur))
                            dxCtrlCompteEmailConfigReception = $("<div/>").appendTo(itemElement).dxCtrlCompteEmailConfigReception({
                                bddCtrl: Me.objet.bddRef,
                                dataCompteEmail: dataCompteEmailCloneReception,
                                dataCompteEmailUtilisateur: dataCompteEmailUtilisateur,
                                allowSave: true,
                                jauge: jaugeDemarrage,
                                onDemandeReloadForOAuth: function () {
                                    option.idAccordion = 1
                                    objet.contentTemplatePopup(contentElement, option)
                                },
                                onChange: function () { mChangeTitle(itemData) },
                                onErreurTestConnexion: function (e) {
                                    dxAccordion.option("selectedItem", ds[1])
                                },
                                onDemandeClosePopupParent: function () { $("body").find(".dx-ctrlpopupobjet").getInstance().hide() },
                                onDemandeConnexionOauthGmail: function () {
                                    mCreateTokenEmailGmail({
                                        bddCtrl: Me.objet.bddRef,
                                        onStart: function () { },
                                        onValide: function (dataCompteEmail, dataCompteEmailUtilisateur) {
                                            dataCompteEmailCloneReception = dataCompteEmail
                                            dataCompteEmailUtilisateur = dataCompteEmailUtilisateur
                                            dataCompteEmailCloneReception.reception_actif = "1"
                                            Me.objet.bddRef.getObjet(dataCompteEmailCloneReception).mSaveChamp("reception_actif", function (data) {
                                                option.idAccordion = 1
                                                objet.contentTemplatePopup(contentElement, option)
                                            })
                                        },
                                        onCancel: function () {
                                            dataCompteEmailCloneReception.reception_actif = "0"
                                            Me.objet.bddRef.getObjet(dataCompteEmailCloneReception).mSaveChamp("reception_actif", function (data) {
                                                option.idAccordion = 1
                                                objet.contentTemplatePopup(contentElement, option)
                                            })
                                        }
                                    })
                                }
                            }).dxCtrlCompteEmailConfigReception("instance")
                            break;
                        case 2:
                            //dataCompteEmailCloneEnvoi = JSON.clone(dataCompteEmailUtilisateur))
                            dxCtrlCompteEmailConfigEnvoi = $("<div/>").appendTo(itemElement).dxCtrlCompteEmailConfigEnvoi({
                                bddCtrl: Me.objet.bddRef,
                                dataCompteEmail: dataCompteEmailCloneEnvoi,
                                dataCompteEmailUtilisateur: dataCompteEmailUtilisateur,
                                allowSave: true,
                                jauge: jaugeDemarrage,
                                onDemandeReloadForOAuth: function () {
                                    option.idAccordion = 2
                                    objet.contentTemplatePopup(contentElement, option)
                                },
                                onChange: function () { mChangeTitle(itemData) },
                                onErreurTestConnexion: function (e) {
                                    dxAccordion.option("selectedItem", ds[2])
                                },
                                showDelivrabilite: (parametre.isLocalhost || Me.objet.bddRef.nom_base.contains("_aagest")),
                                onDemandeClosePopupParent: function () { $("body").find(".dx-ctrlpopupobjet").getInstance().hide() },
                                onDemandeConnexionOauthGmail: function () {
                                    mCreateTokenEmailGmail({
                                        bddCtrl: Me.objet.bddRef,
                                        onStart: function () { },
                                        onValide: function (dataCompteEmail, dataCompteEmailUtilisateur) {
                                            dataCompteEmailCloneEnvoi = dataCompteEmail
                                            dataCompteEmailUtilisateur = dataCompteEmailUtilisateur
                                            dataCompteEmailCloneEnvoi.envoi_actif = "1"
                                            Me.objet.bddRef.getObjet(dataCompteEmailCloneEnvoi).mSaveChamp("envoi_actif", function (data) {
                                                option.idAccordion = 2
                                                objet.contentTemplatePopup(contentElement, option)
                                            })
                                        },
                                        onCancel: function () {
                                            dataCompteEmailCloneEnvoi.envoi_actif = "0"
                                            Me.objet.bddRef.getObjet(dataCompteEmailCloneReception).mSaveChamp("envoi_actif", function (data) {
                                                option.idAccordion = 2
                                                objet.contentTemplatePopup(contentElement, option)
                                            })
                                        }
                                    })
                                }
                            }).dxCtrlCompteEmailConfigEnvoi("instance")
                            break;
                        case 3:
                            $("<div style=''/>").appendTo(itemElement).dxCtrlCompteEmailConfigEnvoiDns({
                                bddCtrl: Me.objet.bddRef,
                                adresse_email: dataCompteEmailCloneEnvoi.adresse_email,
                                dataCompteEmail: dataCompteEmailCloneEnvoi,
                                showDelivrabilite: (parametre.isLocalhost || Me.objet.bddRef.nom_base.contains("_aagest")),
                                envoiQuotidien: false,
                                allowSave:true
                            })
                            break;
                    }
                },
                onSelectionChanged: function (e) {
                    switch (currentSelectedIndex) {
                        case 0:
                            currentSelectedIndex = ds.indexOf(e.addedItems[0])
                            break;
                        case 1:
                            if (dxCtrlCompteEmailConfigReception.hasChange) {
                                dxCtrlCompteEmailConfigReception.mMigreData(objet.data)
                                delete objet.data.envoi_pwd
                                objet.mSave()
                                mChangeTitle(e.addedItems[0])
                                //if (objet.data.reception_actif == "1" &&
                                //    (objet.data.type_token_oauth == null || objet.data.type_token_oauth.length == 0) &&
                                //    !dxCtrlCompteEmailConfigReception.isConfigOk) {
                                //    dxCtrlCompteEmailConfigReception.mTestConnexion(function () {
                                //        dxCtrlCompteEmailConfigReception.mMigreData(objet.data)
                                //        delete objet.data.envoi_pwd
                                //        objet.mSave()
                                //        mChangeTitle(e.addedItems[0])
                                //    }, function (txt) {
                                //        if (typeof txt != "undefined") {
                                //            mNotify(txt, "error", 12000)
                                //            dxAccordion.option("selectedIndex", 1)
                                //        }
                                //    })
                                //} else {
                                //    dxCtrlCompteEmailConfigReception.mMigreData(objet.data)
                                //    delete objet.data.envoi_pwd
                                //    objet.mSave()
                                //    mChangeTitle(e.addedItems[0])
                                //}
                            }
                            currentSelectedIndex = ds.indexOf(e.addedItems[0])
                            break;
                        case 2:
                            if (dxCtrlCompteEmailConfigEnvoi.hasChange) {
                                dxCtrlCompteEmailConfigEnvoi.mMigreData(objet.data)
                                delete objet.data.envoi_pwd
                                objet.mSave()
                                mChangeTitle(e.addedItems[0])
                                //if (!dxCtrlCompteEmailConfigEnvoi.isConfigOk) {
                                //    dxCtrlCompteEmailConfigEnvoi.mTestConnexion(function () {
                                //        dxCtrlCompteEmailConfigEnvoi.mMigreData(objet.data)
                                //        delete objet.data.envoi_pwd
                                //        objet.mSave()
                                //        mChangeTitle(e.addedItems[0])
                                //    }, function (txt) {
                                //        if (typeof txt != "undefined") {
                                //            mNotify(txt, "error", 12000)
                                //            dxAccordion.option("selectedIndex", 2)
                                //        }
                                //    })
                                //} else {
                                //    dxCtrlCompteEmailConfigEnvoi.mMigreData(objet.data)
                                //    delete objet.data.envoi_pwd
                                //    objet.mSave()
                                //    mChangeTitle(e.addedItems[0])
                                //}
                            }
                            currentSelectedIndex = ds.indexOf(e.addedItems[0])
                            break;
                    }
                }
            }).dxAccordion("instance")

            function mChangeTitle(itemData) {
                var txt = itemData.txt
                switch (ds.indexOf(itemData)) {
                    case 0: break;
                    case 1:
                        if (dataCompteEmailCloneReception.reception_actif == "0") { txt += "<span style='font-size:50%;color:" + theme.toastError + ";padding-left:10px;'>La réception n'est pas activée sur ce compte</span>" }
                        else {
                            txt += "<span style='font-size:50%;color:" + theme.toastSuccess + ";padding-left:10px;'>La réception est active sur ce compte"
                            var txtComplete = Me.objet.bddRef.getObjet(dataCompteEmailCloneReception).objetMetier.mGetLibConfig()
                            if (txtComplete.length > 0) txt += " (" + txtComplete + ")"
                            txt += "</span>"
                        }
                        break;
                    case 2:
                        if (dataCompteEmailCloneEnvoi.envoi_actif == "0") { txt += "<span style='font-size:50%;color:" + theme.toastError + ";padding-left:10px;'>Le SMTP de cette adresse n'est pas activé</span>" }
                        else { txt += "<span style='font-size:50%;color:" + theme.toastSuccess + ";padding-left:10px;'>Le SMTP de l'adresse email est actif</span>" }
                        break;
                    case 3:
                        //var domaine = dataCompteEmailCloneEnvoi.adresse_email.split("@")[1]
                        //objet.bddRef.mAjaxCall({ command: "verifycnameemail", domaine: domaine }, function (data) {
                        //    dkimOk = (data.dkimok == "1")
                        //    spfOk = (data.spfok == "1")
                        //    if (dkimOk && spfOk) {
                        //        txt += "<span style='font-size:50%;color:" + theme.toastSuccess + ";padding-left:10px;'>Vos DNS sont correctement configurés sur cette adresse email pour vos envoi en nombre.</span>"
                        //    } else {
                        //        txt += "<span style='font-size:50%;color:" + theme.toastError + ";padding-left:10px;'>Vos DNS ne sont pas correctement configurés sur cette adresse email pour vos envoi en nombre.</span>"
                        //    }
                        //    itemData.titleElement.html(txt);
                        //})
                        break;
                }
                itemData.titleElement.html(txt);
            }
        }
        var onhiding = option.pop.option("onHiding")
        var forceClose = false;
        option.pop.option("onHiding", function (e) {
            onHiding(e)
            if (typeof onhiding != 'undefined') onhiding(e)
        })

        function onHiding(e) {
            if (!forceClose) {
                switch (currentSelectedIndex) {
                    case 1:
                        //e.cancel = true
                        //if (dxCtrlCompteEmailConfigReception != null && dxCtrlCompteEmailConfigReception.hasChange) {
                        //    dxCtrlCompteEmailConfigReception.mTestConnexion(function () {
                        //        dxCtrlCompteEmailConfigReception.mMigreData(objet.data)
                        //        objet.mSave()
                        //        e.cancel = false
                        //        forceClose = true
                        //        option.pop.hide()
                        //        forceClose = false;
                        //    }, function (txt) {
                        //        mNotify(txt, "error", 12000)
                        //    })
                        //} else {
                        //    e.cancel = false
                        //}
                        break;
                    case 2:
                        //e.cancel = true
                        //if (dxCtrlCompteEmailConfigEnvoi != null && dxCtrlCompteEmailConfigEnvoi.hasChange) {
                        //    dxCtrlCompteEmailConfigEnvoi.mTestConnexion(function () {
                        //        dxCtrlCompteEmailConfigEnvoi.mMigreData(objet.data)
                        //        objet.mSave()
                        //        e.cancel = false
                        //        forceClose = true
                        //        option.pop.hide()
                        //        forceClose = false;
                        //    }, function (txt) {
                        //        mNotify(txt, "error", 12000)
                        //    })
                        //} else {
                        //    e.cancel = false
                        //}
                        break;
                }
            }
        }
    }

    this.mShowPopup = function (optionPopup) {
        if (typeof optionPopup == 'undefined' || optionPopup == null) optionPopup = {}
        optionPopup.width = 550
        optionPopup.showMaximize = false;
        optionPopup.onDelete = function () {
            if (objet.data.id_utilisateur != Me.objet.bddRef.utiCourant.id_utilisateur) {
                //l'utilisateur ne posède pas l'email
                var dataCptEmailUtilisateur = Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (o) { return o.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur && o.id_compte_email == objet.data.id_compte_email })[0]
                if (typeof dataCptEmailUtilisateur != 'undefined') {
                    Me.objet.bddRef.getObjet(dataCptEmailUtilisateur).mDelDataDefinitif()
                } else {
                    mNotify("Impossible de supprimer ce compte email")
                    return false
                }
            } else { objet.mDelData() }
            return true;
        }
        optionPopup.onTitleCmdTemplate = function (titleElement, popupBase) {
            $("<div/>").appendTo(titleElement).dxCtrlButton({
                text: "Migrer",
                hint: "Migrer ce compte email vers un autre utilisateur",
                onClick: function (e) {
                    var dataCptEmailUtilisateur = Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (o) { return o.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur && o.id_compte_email == objet.data.id_compte_email })[0]
                    if (typeof dataCptEmailUtilisateur != 'undefined') {
                        //ce mail appartient à un autre utilisateur
                        //saisir le mot de passe de l'utilisateur          
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            width: 350,
                            showCloseButton: false,
                            visible: true,
                            contentTemplate: function (contentElement) {
                                contentElement.css("white-space", "normal")
                                contentElement.css("padding", "20px")
                                var objUti = Me.objet.bddRef.getObjet("utilisateur", objet.data.id_utilisateur)
                                $("<div>Cette adresse email appartient à l'utilisateur<br/><b>" + objUti.mGetLib1() + "</b><br/><br/>Veuillez saisir le mot de passe de l'utilisateur<br/>pour pouvoir migrer ce compte email.</div>").appendTo(contentElement)
                                var dtxTextBoxPwd = $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlTextBox({
                                    width: 330,
                                    labelMode: 'floating',
                                    label: "Mot de passe de l'utilisateur",
                                    value: "",
                                    showClearButton: false,
                                    placeholder: "Mot de passe",
                                    maxLength: 100,
                                    buttons: [{
                                        focusStateEnabled: false,
                                        name: 'showpwd',
                                        location: 'after',
                                        options: {
                                            icon: 'eyeopen',
                                            hint: "Révéler/cacher le texte",
                                            focusStateEnabled: false,
                                            stylingMode: 'text',
                                            onClick() {
                                                if (dtxTextBoxPwd.element().find("input").hasClass("txtPassword")) {
                                                    if (dtxTextBoxPwd.option("value") != null && dtxTextBoxPwd.option("value").contains("xxxxx")) {
                                                        //Le mot de passe est en mémoire et ne peut être révélé
                                                        dtxTextBoxPwd.option("value", "")
                                                        mNotify("Le mot de passe en mémoire ne peut être révélé.<br/>Celui-ci a été retiré.<br/>Vous pouvez maintenant saisir votre nouveau mot de passe", "warning", 6000)
                                                    }
                                                    dtxTextBoxPwd.element().find("input").removeClass("txtPassword")
                                                } else {
                                                    dtxTextBoxPwd.element().find("input").addClass("txtPassword")
                                                }
                                            },
                                        },
                                    }],
                                    onContentReady: function (e) {
                                        e.component.element().find("input").addClass("txtPassword")
                                    }
                                }).dxCtrlTextBox("instance")

                                $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Valider",
                                    onClick: function (e) {
                                        if (dtxTextBoxPwd.option("value") == null || dtxTextBoxPwd.option("value").length == 0) {
                                            mNotify("Veuillez saisir le mot de passe de l'utilisateur.", "warning", 6000)
                                            dtxTextBoxPwd.focus()
                                        } else {
                                            Me.objet.bddRef.mAjaxCall({ command: "verifutipwd", email: objUti.data.adresse_email, pwd: dtxTextBoxPwd.option("value") }, function (data) {
                                                if (data.pwdok == "1") {
                                                    tt.hide()
                                                    mDisplayLstUtilisateur()
                                                } else {
                                                    mNotify("Le mot de passe est erroné.", "warning", 6000)
                                                    dtxTextBoxPwd.focus()
                                                }
                                            })
                                        }
                                    }
                                })

                            }
                        }).dxCtrlTooltip("instance");
                        tt.show();

                    } else {
                        //ce mail appartient à l'utilisateur
                        mDisplayLstUtilisateur()
                    }

                    function mDisplayLstUtilisateur() {
                        var tt2 = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            width: 350,
                            showCloseButton: false,
                            visible: true,
                            contentTemplate: function (contentElement) {
                                contentElement.css("white-space", "normal")
                                contentElement.css("padding", "20px")
                                $("<div>Veuillez sélectionner l'utilisateur chez qui migrer le compte email.</div>").appendTo(contentElement)
                                Me.objet.bddRef.mGetArray("utilisateur").filter(function (o) { return o.date_abandon == null && o.is_robot == 0 && o.id_utilisateur != objet.data.id_utilisateur }).forEach(function (dataUti) {
                                    var objUti = Me.objet.bddRef.getObjet(dataUti)
                                    var $DivVide = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                                        "style='padding:10px 0;width:100%;height:auto;text-align:left;margin:10px 0;line-height:1;'>" +
                                        "<div class='contenu' style='padding:5px;'>" +
                                        "<span style='font-size:100%;font-style:italic' class='detail'>Migrer sur: <b>" + objUti.mGetLib1() + "</b>"
                                        + "</span>" +
                                        "</div>" +
                                        "</div>").appendTo(contentElement)
                                    $DivVide.on("click", function (e) {
                                        tt2.hide()
                                        mConfirmMigrationUtilisateur(objUti)
                                    })
                                })
                            }
                        }).dxCtrlTooltip("instance");
                        tt2.show();
                    }

                    function mConfirmMigrationUtilisateur(objUti) {
                        var tt3 = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            width: 350,
                            showCloseButton: false,
                            visible: true,
                            contentTemplate: function (contentElement) {
                                contentElement.css("white-space", "normal")
                                contentElement.css("padding", "20px")
                                $("<div>Migrer le compte email sur l'utilisateur</div>").appendTo(contentElement)
                                $("<div><b>" + objUti.mGetLib1() + "</b></div>").appendTo(contentElement)
                                $("<div style='margin-top:10px;'>A la fin de la migration, votre environnement sera rechargé</div>").appendTo(contentElement)
                                $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Confirmer",
                                    onClick: function (e) {
                                        jaugeDemarrage.mShow()
                                        Me.objet.bddRef.mAjaxCall({
                                            command: "migrecompteemail",
                                            id_compte_email: objet.data.id_compte_email,
                                            id_utilisateur_new: objUti.data.id_utilisateur
                                        }, function (data) {
                                            forcerFermetureNavigateur = true;
                                            window.location.reload()
                                        }, null,
                                            function () {
                                                tt3.hide()
                                                jaugeDemarrage.mHide()
                                                mNotify("Impossible de miger le compte email", "warning", 6000)
                                            })
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance");
                        tt3.show();
                    }
                }
            })
        }
        optionPopup.onHidden = function () {
            //Me.objet.bddRef.getObjet("compte_email").objetMetier.mShowWarningSmtpPopup(objet.data.adresse_email)
        }
        return objet.mShowPopupInterne(optionPopup)
    }

    this.mGetLibConfig = function () {
        var txtComplete = ""
        if (objet.data.reception_date_antispam != null) txtComplete += "ANTISPAM"
        //if (objet.data.reception_date_debut != null) {
        //    txtComplete += ((txtComplete.length > 0) ? " &bull; " : "") + "RECOIT≧" + objet.data.reception_date_debut.toFrenchDateTime(true)
        //    if (objet.data.reception_nb_jour_supp != null) {
        //        txtComplete += ((txtComplete.length > 0) ? " &bull; " : "") + "SUPPR.-" + objet.data.reception_nb_jour_supp + "jrs"
        //    }
        //}
        return txtComplete
    }

    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var $Table = $("<table style='table-layout:fixed;width:100%;text-align:left;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdUti = $("<td style='width:30px;padding:0 3px;height:1px;'/>").appendTo($Tr)
        $("<div style='width:100%;height:100%;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1()
        })

        var $TdDest = $("<td style='width:100%;padding:0 3px;height:1px;'>Compte email: <u>" + dataTemplate.adresse_email + "</u></td>").appendTo($Tr)
    }

    this.mGetNomUsuelCourant = function () {
        var nomUsuel =  ""
        var dataCompteEmailUtilisateur = this.mGetDataCompteEmailUtilisateur(objet.bddRef.utiCourant.id_utilisateur)
        if (dataCompteEmailUtilisateur.nom_usuel != null && dataCompteEmailUtilisateur.nom_usuel.length > 0) {
            nomUsuel = dataCompteEmailUtilisateur.nom_usuel
        } else if (objet.bddRef.utiCourant.nom_usuel != null && objet.bddRef.utiCourant.nom_usuel.length > 0) {
            nomUsuel = objet.bddRef.utiCourant.nom_usuel
        } else {
            nomUsuel = objet.bddRef.getObjet(objet.bddRef.utiCourant).objetMetier.mGetNomUsuel()
        }

        //var dataCompteEmailUti = this.mGetDataCompteEmailUtilisateur()
        //var nomUsuel = dataCompteEmailUti.nom_usuel
        //if (typeof nomUsuel == 'undefined' || nomUsuel == null || nomUsuel.length == 0) {
        //    nomUsuel = Me.objet.bddRef.getObjet(Me.objet.bddRef.utiCourant).objetMetier.mGetNomUsuelCourant()
        //}
        return nomUsuel
    }

    this.mSetNomUsuelCourant = function (nomUsuel) {
        var dataCompteEmailUti = this.mGetDataCompteEmailUtilisateur()
        dataCompteEmailUti.nom_usuel = nomUsuel
        Me.objet.bddRef.getObjet(dataCompteEmailUti).mSaveChange("nom_usuel")
    }

    this.templateTitleEmail = function (contentElement, idUtilisateur, option) {
        //if (typeof contentElement.hasTrigger == "undefined") {
        //    Me.objet.bddRef.mAddFunctionOnModifiedItemData(["compte_email"], contentElement,
        //        function (action, itemData) {
        //            if (itemData.id_compte_email == objet.data.id_compte_email && action == "modif") {
        //                objet.data = itemData
        //                Me.templateTitleEmail(contentElement, idUtilisateur, option)
        //            }
        //        })
        //    contentElement.hasTrigger = true
        //}

        contentElement.empty()
        if (typeof option == 'undefined') option = {}
        contentElement.css("font-size", "100%")
        contentElement.css("position", "relative")
        var $Table = $("<table style='width:100%;height:100%;table-layout:fixed;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var dataCompteEmailUti = this.mGetDataCompteEmailUtilisateur(idUtilisateur)
        if (this.hasReponseAuto()) {
            var $Td = $("<td style='width:20px;overflow: hidden;text-overflow: ellipsis;position:relative;font-family:barlow condensed;font-size:115%;white-space:nowrap;line-height:1;'></td>").appendTo($Tr)
            var $RepAuto = $("<span><i class='fas fa-shop-slash blinkscalealways state-hover' style='color:GoldenRod;font-size:90%;'></i>&nbsp;&nbsp;</span>").appendTo($Td)
            $RepAuto.attr("title", this.htmlInfoReponseAuto())
            $RepAuto.on("click", function (e) {
                e.stopPropagation()
                var dataForRepAuto = Me.mGetDataForReponseAuto()
                if (dataForRepAuto == "compte_email") { objet.mShowPopup({ id_utilisateur: idUtilisateur }) }
                else if (dataForRepAuto == "compte_client") {
                    $("<div/>").appendTo("body").dxCtrlPopupContentCompteClientForUtilisateur({
                        bddCtrl: Me.objet.bddRef,
                        showEmail: true
                    })
                } else { Me.objet.bddRef.getObjet(Me.mGetDataForReponseAuto()).mShowPopup({ showEmail: true }) }
            })
        }
        if (dataCompteEmailUti.defaut == "1") {
            var $Td = $("<td style='width:20px;overflow: hidden;text-overflow: ellipsis;position:relative;font-family:barlow condensed;font-size:115%;white-space:nowrap;line-height:1;'></td>").appendTo($Tr)
            $("<span><i class='fas fa-bookmark' style='color:green' title='Adresse email par défaut'>&nbsp;</span>").appendTo($Td).attr("title","Adresse email par défaut<br/>Pour changer votre adresse email par défaut, ouvrez la configuration de la nouvelle adresse pour la définir par défaut.")
        }
        var $Td = $("<td style='width:100%;overflow: hidden;text-overflow: ellipsis;position:relative;font-family:barlow condensed;font-size:115%;white-space:nowrap;line-height:1;'></td>").appendTo($Tr)
        $("<div>" + objet.data.adresse_email + "</div>").appendTo($Td)
        var $DivAlerte = $("<div style='font-size:70%;color:orange;opacity:0.7;'/>").appendTo($Td)
        if (objet.data.reception_actif == "0" || objet.data.envoi_actif == "0") {
            if (objet.data.reception_actif == "0") {
                var $Span = $("<span>Réception désactivée</span>").appendTo($DivAlerte)
                $Span.addClass("state-hover")
                $Span.on("click", function (e) {
                    e.stopPropagation()
                    Me.mShowPopup({
                        id_utilisateur: objet.bddRef.utiCourant.id_utilisateur,
                        idAccordion: 1
                    })
                })
            }
            if (objet.data.envoi_actif == "0") {
                if (objet.data.reception_actif == "0") $("<span> &bull; </span>").appendTo($DivAlerte)
                var $Span = $("<span>Pas de smtp perso</span>").appendTo($DivAlerte)
                $Span.addClass("state-hover")
                $Span.on("click", function (e) {
                    e.stopPropagation()
                    Me.mShowPopup({
                        id_utilisateur: objet.bddRef.utiCourant.id_utilisateur,
                        idAccordion: 2
                    })
                })
            }
        }

        if (objet.data.reception_actif == "1" && objet.data.reception_derniere_erreur_cnx != null
            && objet.data.reception_derniere_erreur_cnx.length > 0 && objet.data.reception_date_derniere_erreur_cnx != null) {
            //erreur de connexion
            if ($DivAlerte.text().length > 0) $("<span> &bull; </span>").appendTo($DivAlerte)
            var $Span = $("<span>Erreur réception " + objet.data.reception_date_derniere_erreur_cnx.toDateIlya(true) + "</span>").appendTo($DivAlerte)
            $Span.attr("title", parametre.nom + " a tenté de recevoir vos emails mais a rencontré une erreur en interrogeant le serveur. Cliquer et vérifier la configuration de la réception.")
            $Span.addClass("state-hover")
            $Span.on("click", function (e) {
                e.stopPropagation()
                Me.mShowPopup({
                    id_utilisateur: objet.bddRef.utiCourant.id_utilisateur,
                    idAccordion: 1
                })
            })
        }
        if (objet.data.envoi_actif == "1" && objet.data.envoi_derniere_erreur_cnx != null
            && objet.data.envoi_derniere_erreur_cnx.length > 0 && objet.data.envoi_date_derniere_erreur_cnx != null) {
            //erreur de connexion
            if ($DivAlerte.text().length > 0) $("<span> &bull; </span>").appendTo($DivAlerte)
            var $Span = $("<span>SMTP en erreur " + objet.data.envoi_date_derniere_erreur_cnx.toDateIlya(true) + "</span>").appendTo($DivAlerte)
            $Span.attr("title", parametre.nom + " a tenté d'envoyer des emails mais a rencontré une erreur en interrogeant le serveur. Cliquer et vérifier la configuration de l'envoi.")
            $Span.addClass("state-hover")
            $Span.on("click", function (e) {
                e.stopPropagation()
                Me.mShowPopup({
                    id_utilisateur: objet.bddRef.utiCourant.id_utilisateur,
                    idAccordion: 2
                })
            })
        }

        var $DivCompteur = $("<div style='padding:2px 4px 2px 3px;font-family:barlow condensed;position:absolute;top:2px;right:5px;font-size:70%;background-color:" + theme.backgroundColorCompteur + ";border-radius:5px;font-weight:500;display:none;color:" + theme.backgroundcolorTooltip + ";' class='count'></div>").appendTo(contentElement)
        //var $DivCompteur = $("<div style='border-radius:5px;background-color:" + theme.backgroundcolorTooltip + ";opacity:1;position:absolute;display:none;min-width:18px;top:2px;right:2px;' class='dx-theme-accent-as-text-color'><div style='border-radius:5px;padding:3px;font-weight:bold;background-color:" + theme.backgroundcolorTooltip + ";font-size:80%;font-family:barlow condensed;opacity:0.8;line-height:110%;text-align:center;'></div></div>").appendTo(contentElement)
        ////var $DivCompteur = $("<div style='border-radius:50%;background-color:red;opacity:0.6;position:absolute;display:none;min-width:18px;top:0px;right:0px;'><div style='border-radius:50%;padding:3px;font-weight:bold;background-color:red;font-size:80%;opacity:0.8;line-height:110%;text-align:center;'></div></div>").appendTo(contentElement)
        var nb = 0
        function mUpdateCompteur() {
            if ($DivCompteur.closest("body").length == 0) return
            var nbRecu = ((Me.objet.bddRef.msgEmailSms == null) ? 0 : Me.objet.bddRef.msgEmailSms.mGetNbEmail([1], objet.data.adresse_email, "1"))
            var nbErreur = ((Me.objet.bddRef.msgEmailSms == null) ? 0 : Me.objet.bddRef.msgEmailSms.mGetDsEmailErreur(objet.data.adresse_email, false).nb)
            var val = ((Me.objet.bddRef.msgEmailSms == null) ? null : Me.objet.bddRef.msgEmailSms.mGetHtmlEtTooltipForEmailNb(nbRecu, nbErreur))
            if (val != null && val.html.length > 0) {
                $DivCompteur.attr("title", val.title)
                $DivCompteur.html(val.html)
                $DivCompteur.css("display", "")
            } else {
                $DivCompteur.css("display", "none")
            }
            //if ($DivCompteur.closest("body").length == 0) return
            //var oldNb = nb
            //nb = Me.objet.bddRef.msgEmailSms.mGetNbEmail([1], objet.data.adresse_email, "1")
            //if (oldNb != nb) {
            //    if (nb > 999) { $($DivCompteur.find("div")).text("∾") }
            //    else { $($DivCompteur.find("div")).text(nb) }
            //    $DivCompteur.css("display", ((nb == 0) ? "none" : ""))
            //}
        }
        $(window).on("changeNbEmail", function (e) { if (contentElement.closest("body").length > 0) mUpdateCompteur() });
        mUpdateCompteur()


        var $TdCog = $("<td style='width:20px;opacity:0.3;' rowspan='2'/>").appendTo($Tr)
        $("<div style='display:inline-block;'/>").appendTo($TdCog).dxCtrlButton({
            icon: "fas fa-cog",
            txtTooltip: "Configuration de l'adresse email <u>" + objet.data.adresse_email + "</u>",
            height: 20,
            width: 20,
            onClick: function (e) {
                e.event.preventDefault()
                e.event.stopPropagation()
                if (option.showReception) { option.idAccordion = 1 }
                else if (option.showEnvoi) { option.idAccordion = 2 }
                option.id_utilisateur = idUtilisateur
                objet.mShowPopup(option)
            }
        })
        $Table.on("mouseenter", function () {
            $TdCog.css("opacity", "1")
            $TdNew.css("opacity", "1")
        })
        $Table.on("mouseleave", function () {
            $TdCog.css("opacity", "0.3")
            $TdNew.css("opacity", "0.6")
        })

        var $TdNew = $("<td style='width:36px;opacity:0.6;'/>").appendTo($Tr)
        $("<div/>").appendTo($TdNew).dxCtrlButton({
            icon: "fas fa-envelope",
            icon2: "fas fa-certificate",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            hint: "Nouvel email brouillon sur <u>" + objet.data.adresse_email + "</u>",
            height: 28,
            width: 28,
            onClick: function (e) {
                e.event.stopPropagation()
                Me.objet.bddRef.getObjet("com_email_envoi").objetMetier.mShowNewEmail(false, objet.data)
            }
        }).dxCtrlButton("instance")

        return $Table
    }

    this.hasReponseAuto = function () {
        if (Me.objet.bddRef.objCptCli.data.repauto_actif == "1" &&
            (Me.objet.bddRef.objCptCli.data.repauto_debut == null || Me.objet.bddRef.objCptCli.data.repauto_debut <= parametre.dateNow) &&
            (Me.objet.bddRef.objCptCli.data.repauto_fin == null || Me.objet.bddRef.objCptCli.data.repauto_fin >= parametre.dateNow)) {
            return true
        } else {
            var dataUti = Me.objet.bddRef.mGetArray("utilisateur").filter(function (uti) { return uti.id_utilisateur == objet.data.id_utilisateur })[0]
            if (dataUti.repauto_actif == "1" &&
                (dataUti.repauto_debut == null || dataUti.repauto_debut <= parametre.dateNow) &&
                (dataUti.repauto_fin == null || dataUti.repauto_fin >= parametre.dateNow)) {
                return true
            } else if (objet.data.repauto_actif == "1" &&
                (objet.data.repauto_debut == null || objet.data.repauto_debut <= parametre.dateNow) &&
                (objet.data.repauto_fin == null || objet.data.repauto_fin >= parametre.dateNow)) {
                return true
            }
        }
        return false
    }
    this.htmlInfoReponseAuto = function () {
        if (Me.objet.bddRef.objCptCli.data.repauto_actif == "1" &&
            (Me.objet.bddRef.objCptCli.data.repauto_debut == null || Me.objet.bddRef.objCptCli.data.repauto_debut <= parametre.dateNow) &&
            (Me.objet.bddRef.objCptCli.data.repauto_fin == null || Me.objet.bddRef.objCptCli.data.repauto_fin >= parametre.dateNow)) {
            return "Une réponse automatique active<br/>est définie au niveau du compte client"
        } else {
            var dataUti = Me.objet.bddRef.mGetArray("utilisateur").filter(function (uti) { return uti.id_utilisateur == objet.data.id_utilisateur })[0]
            if (dataUti.repauto_actif == "1" &&
                (dataUti.repauto_debut == null || dataUti.repauto_debut >= parametre.dateNow) &&
                (dataUti.repauto_fin == null || dataUti.repauto_fin <= parametre.dateNow)) {
                return "Une réponse automatique active<br/>est définie au niveau du compte utilisateur"
            } else if (objet.data.repauto_actif == "1" &&
                (objet.data.repauto_debut == null || objet.data.repauto_debut >= parametre.dateNow) &&
                (objet.data.repauto_fin == null || objet.data.repauto_fin <= parametre.dateNow)) {
                return "Une réponse automatique active<br/>est définie au niveau du compte email"
            }
        }
        return ""
    }
    this.mGetDataForReponseAuto = function () {
        if (Me.objet.bddRef.objCptCli.data.repauto_actif == "1" &&
            (Me.objet.bddRef.objCptCli.data.repauto_debut == null || Me.objet.bddRef.objCptCli.data.repauto_debut <= parametre.dateNow) &&
            (Me.objet.bddRef.objCptCli.data.repauto_fin == null || Me.objet.bddRef.objCptCli.data.repauto_fin >= parametre.dateNow)) {
            return "compte_client"
        } else {
            var dataUti = Me.objet.bddRef.mGetArray("utilisateur").filter(function (uti) { return uti.id_utilisateur == objet.data.id_utilisateur })[0]
            if (dataUti.repauto_actif == "1" &&
                (dataUti.repauto_debut == null || dataUti.repauto_debut >= parametre.dateNow) &&
                (dataUti.repauto_fin == null || dataUti.repauto_fin <= parametre.dateNow)) {
                return dataUti
            } else if (objet.data.repauto_actif == "1" &&
                (objet.data.repauto_debut == null || objet.data.repauto_debut >= parametre.dateNow) &&
                (objet.data.repauto_fin == null || objet.data.repauto_fin <= parametre.dateNow)) {
                return "compte_email"
            }
        }
        return null
    }

    this.mShowPopupNew = function (dataUtilisateur) {
        if (typeof dataUtilisateur == 'undefined') dataUtilisateur = Me.objet.bddRef.utiCourant
        var dxWizard = $("<div/>").appendTo("body").dxCtrlWizardConfigCompteEmail({
            bddCtrl: Me.objet.bddRef,
            dataUtilisateur: dataUtilisateur
        })
        dxWizard.show()
    }

    //this.mShowWarningSmtpPopup = function (adresseEmail) {
    //    var lstCompteKo = Me.objet.bddRef.mGetArray("compte_email").filter(function (cpt) { return cpt.envoi_actif == "0" && cpt.message_smtp_off == "0" })
    //    if (typeof adresseEmail != 'undefined' && adresseEmail != null) lstCompteKo.filter(function (cpt) { return cpt.adresse_email == adresseEmail })
    //    if (lstCompteKo.length > 0) {
    //        notify.mShow({
    //            message: function (contentElement, popup) {
    //                contentElement.css("font-size", "90%")
    //                if (lstCompteKo.length > 1) {
    //                    $("<div>Certaines de vos adresses emails ne dispose pas d'un SMTP actif.</div>").appendTo(contentElement)
    //                } else {
    //                    $("<div>L'adresse email <u>" + lstCompteKo[0].adresse_email + "</u> ne dispose pas d'un SMTP actif.</div>").appendTo(contentElement)
    //                }
    //                for (var i = 0; i < 200; i++) {
    //                    $("<br/>").appendTo(contentElement)
    //                }
    //                $("<div>Le fait de ne pas disposer d'un smtp actif sur une adresse email peut entrainer de nombreux problème de délivrabilité.<br/>Il est fortement conseillé de configurer le SMTP de l'adresse email pour disposer d'une délivrabilité optimal.</div>").appendTo(contentElement)
    //                $("<br/>").appendTo(contentElement)

    //                lstCompteKo.forEach(function (cpt) {
    //                    $("<div style='padding-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
    //                        width: "100%",
    //                        html: "Configurer le SMTP de<br><u>" + cpt.adresse_email + "</u>",
    //                        onClick: function (e) {
    //                            var popupCpt = Me.objet.bddRef.getObjet(cpt).objetMetier.mShowPopup()
    //                            var accordion = popupCpt.contentElement.find(".accordionemail")
    //                            var dxAccordion = $(accordion).dxAccordion("instance")
    //                            dxAccordion.expandItem(2)
    //                            popup.hide()
    //                            //debugger;
    //                        }
    //                    })
    //                    $("<div style='padding-top:3px;'/>").appendTo(contentElement).dxCtrlCheckBox({
    //                        text: "Ne plus afficher ce message pour cette adresse email",
    //                        checked: true,
    //                        onValueChanged: function (e) {
    //                            cpt.message_smtp_off = ((e.value) ? "1" : "0")
    //                            Me.objet.bddRef.getObjet(cpt).mSaveChamp("message_smtp_off")
    //                        },
    //                        onContentReady: function (e) { e.element.find(".dx-checkbox-text").css("font-size", "70%") }
    //                    })
    //                })
    //            },
    //            titre: "<span style='color:red;'>SMTP adresse email non configuré</smtp>",
    //            img: "<i class='fas fa-exclamation-triangle' style='font-size:50px'/>",
    //            tempoSeconde: 12000
    //        });
    //    }

    //}

    this.mGetDataCompteEmailUtilisateur = function (idUtilisateur) {
        if (typeof idUtilisateur == 'undefined') idUtilisateur = Me.objet.bddRef.utiCourant.id_utilisateur
        return Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (o) {
            return o.id_compte_email == objet.data.id_compte_email && o.id_utilisateur == idUtilisateur
        })[0]
    }

}